import { Provider } from "react-redux";
import Navbar from "./components/Navbar";
import store from "./redux/store";
import Body from "./components/Body";

function App() {
    return (
        <Provider store={store}>
            <Navbar />
            <main class="py-16" >
                <Body />
            </main>
        </Provider>
    );
}

export default App;
